<template>
    <div class="product-service-section-container">
        <section-title :text="title"/>
        <div class="section-main">
            <a v-for="data in dataList" :key="data.name" :class="['cls-item', hasLink && 'cls-item-hover']" :href="data.link" target="_blank">
                <img :src="data.logoUrl" :alt="data.name" class="cls-img">
                <div class="item-one-row">
                    <div class="item-name">{{data.name}}</div>
                    <!-- <span class="cls-img-icon" v-if="hasLink"></span> -->
                </div>
                <div class="item-content">{{data.describe}}</div>
            </a>
        </div>
    </div>
</template>

<script>
import sectionTitle from "./sectionTitle.vue";
export default {
  name: "productServiceSection",
  components: {
    sectionTitle: sectionTitle
  },
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: "产品服务"
    },
    dataList: {
      type: Array,
      default: [
        {
          logoUrl:
            "//img10.360buyimg.com/img/jfs/t1/208223/14/2370/36107/6151624aE516d7f7e/d96cd018be505c37.png",
          name: "全域监测",
          link: '/cloud/cdp',
          describe:
            "给客户提供一套全域数据回收方案，覆盖全场景全链路的数据回流方案"
        },
        {
          logoUrl:
            "//img10.360buyimg.com/img/jfs/t1/197278/31/10372/36785/6151624aEb9a3d467/ba01a6c2cc7015bf.png",
          name: "P-DSP",
          link: '/cloud/dsp',
          describe:
            "给客户搭建私有部署DSP，保证一方数据安全情况下快速连通全域广告触点"
        },
        {
          logoUrl:
            "//img10.360buyimg.com/img/jfs/t1/198561/3/10313/39430/6151624aEdff72ea3/0c5040e07e93f651.png",
          name: "星图-DMP",
          link: '/cloud/dmp',
          describe:
            "助力客户开展精细化投放，包含线上线下、APP、金融和企业等多维度数据"
        },
        {
          logoUrl:
            "//img10.360buyimg.com/img/jfs/t1/92296/30/17866/34680/6151624aE3e3ee857/d94f314aebe43bc4.png",
          name: "营销云RTA",
          link: '/cloud/rta',
          describe:
            "一套面向线上实时投放的数据安全方案，通过数据赋能提升投放效果"
        }
      ]
    },
    hasLink: {
      type: Boolean,
      default: true
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.product-service-section-container {
  width: 100%;
  height: 400px;
  padding: 86px 0 0px;
  background: linear-gradient(180deg, #f0f2ff 0%, #fbfcff 48.13%, white 100%);

  .section-main {
    width: 1200px;
    margin: 50px auto 0;
    display: flex;
    justify-content: center;
    .gap36 {
      padding: 0 36px;
    }
    .gap24 {
      padding: 0 24px;
    }
    .cls-item {
      flex: 1;
      border-right: 1px dashed #e5e5e5;
      cursor: pointer;

      &:last-child {
        border-right: none;
      }

      .cls-img {
        width: 128px;
        height: 107px;
        display: block;
        margin: 0 auto;
      }

      .item-one-row {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;

        .item-name {
          line-height: 22px;
          font-size: 18px;
          font-weight: 500;
          color: #333;
          padding: 0 20px;
          margin: auto;
        }

        .cls-img-icon {
          width: 21px;
          height: 16px;
          background-size: cover;
          background-position: 50%;
          background-image: url(//img10.360buyimg.com/img/jfs/t1/87751/4/18584/1023/614c3b5aE7136004e/983857006a403af9.png);
        }
      }

      .item-content {
        margin-top: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #666;
        width: 335px;
        padding: 0 50px;
        text-align: center;
      }
    }

    .cls-item-hover {
				cursor: pointer;
				&:hover {
					.item-name {
						color: #3247FF;
					}
					.cls-img-icon {
						background-image: url('//img10.360buyimg.com/img/jfs/t1/162994/25/22096/1011/614c3b5aEf4306d24/326b3adde2af08d2.png');
					}
				}
			}
  }
}
</style>

